export default __webpack_public_path__ + "static/B27-a58c333e1d440415019d880b7d05dfe5.png";